import { useStage } from './useStage'

export default () => useStage('face-enrollment')
